import { ApiMediasFile } from "@/services/medias/schemas"
import { ApiSeo } from "@/services/seos/schemas"

export const extractFilesFromSeo = (seo: ApiSeo): ApiMediasFile[] => [
  ...seo.files,
  ...A.filterMap(seo.translations, ({ image }) => (G.isNotNullable(image) ? image : O.None)),
]
